import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Button as BaseButton } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ProductsForm from '@app/components/apps/Products/ProductsForm';
import { useLocation } from 'react-router-dom';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const EditProductPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Location');

  const routes = [
    {
      path: '/products',
      breadcrumbName: 'Products',
    },
    {
      path: '/edit-product',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ProductsForm
          type={'edit'}
          editable={true}
          id={id}
          pageTitle={`Edit Product`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default EditProductPage;
